export const VALIDATION_MESSAGES = {
  FIRST_NAME_REQUIRED: "First name is required",
  LAST_NAME_REQUIRED: "Last name is required",
  EMAIL_REQUIRED: "Email is required",
  INVALID_MAIL: "Invalid email",
  MOBILE_NUMBER: "Mobile number is required",
  USER_UPDATED: "User Updated Successfully",
  FAILED_UPDATE_USER: "Failed to update user",
  FAILED_FETCH_USERS: "Failed to fetch user data"
};